import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormConfigCard from "../../../../components/formConfigCards/formConfigCard";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import { fetchFormConfigfromFirebase } from "../../../../redux/slice/formConfigSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import Header from "./component/header";

const FormConfig = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { formConfigs, loading } = useSelector(
    (state: RootState) => state.formConfig,
  );
  const unsubscribeRef = useRef<(() => void) | undefined>();
  const navigate = useNavigate();

  useEffect(() => {
    const setupListener = async () => {
      unsubscribeRef.current = await dispatch(fetchFormConfigfromFirebase());
    };
    setupListener();

    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, [dispatch]);

  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-hidden">
      {loading ? (
        <div className="flex h-full w-full items-center justify-center">
          <LoaderMessage message="Loading form configurations..." />
        </div>
      ) : (
        <>
          <Header />
          <div className="flex flex-1 flex-col gap-3 overflow-auto">
            {formConfigs.map((config) => (
              <FormConfigCard
                key={config?.id}
                formTitle={config?.data?.formTitle || ""}
                createdAt={config?.created_at}
                updatedAt={config?.updated_at}
                updatedBy={config?.updated_by}
                onArrowClick={() => {
                  navigate(
                    `/configurations/form-configuration/form-config/${config?.id}`,
                  );
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default FormConfig;
